import dynamic from "next/dynamic";

export const DynamicContent038 = dynamic(() => import("./Content038"), {
  suspense: true,
});
